<template>
  <div
    :class="['api-follow-drag']"
    ref="dragDom"
    v-if="showDom"
    data-sensors-exposure-event-name="Diversion_Exposure" 
    data-sensors-exposure-property-exposure_type="FLOAT"
    :data-sensors-exposure-property-exposure_txt="flow.key"
    @click="showDialog"
  >
    <i class="wave" v-if="flow.guidPageFlag==='Y'"></i>
    <div class="container"><img :src="flow.content" ></div>
    <i class="close" @click="handleClose"></i>
  </div>
</template>

<script>

export default {
  props: {
    flow: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      isDragged: false,
      showDom: true,
      domLeft: 0,
      domTop: 0,
      initX: 0,
      initY: 0,
      open: true,
      visible: true,
      topPosition: 0 // 页面顶部的限制距离
    }
  },
  mounted () {
    const dragDom = this.$refs.dragDom
    if (!dragDom) return
    // 页面宽度和高度
    const pageWidth = document.documentElement.clientWidth
    let pageHeight = document.documentElement.clientHeight
    // 拖拽元素宽度和高度
    const dragWidth = dragDom.offsetWidth
    const dragHeight = dragDom.offsetHeight

    // 初始化位置信息
    const dragPosition = JSON.parse(
      sessionStorage.getItem('followDragPosition') || 'null'
    )
    if (dragPosition) {
      dragDom.style.top = dragPosition.top
      if (dragPosition.left) {
        dragDom.style.left = dragPosition.left
      } else {
        // 默认靠右显示
        dragDom.style.left = `${pageWidth - dragWidth - 10}px`
      }
    } else {
      dragDom.style.top = pageHeight - dragHeight - 250 + 'px'
      // 默认靠右显示
      dragDom.style.left = `${pageWidth - dragWidth - 10}px`
    }
    dragDom.addEventListener('touchstart', (e) => {
      e.stopPropagation()
      this.isDragged = true
      this.initX = e.touches[0].clientX
      this.initY = e.touches[0].clientY
      this.domLeft = dragDom.offsetLeft
      this.domTop = dragDom.offsetTop
    })
    dragDom.addEventListener('touchmove', (e) => {
      e.preventDefault()
      e.stopPropagation()
      if (this.isDragged) {
        const x = e.touches[0].clientX
        const y = e.touches[0].clientY
        // 鼠标移动的距离
        const offsetX = x - this.initX
        const offsetY = y - this.initY
        // 鼠标移动后元素的新位置
        const newLeft = this.domLeft + offsetX
        const newTop = this.domTop + offsetY

        if (newLeft < 0) {
          dragDom.style.left = 10 + 'px'
        } else if (newLeft > pageWidth - dragWidth) {
          dragDom.style.left = pageWidth - dragWidth + 'px'
        } else {
          dragDom.style.left = newLeft + 'px'
        }
        if (newTop < this.topPosition) {
          dragDom.style.top = this.topPosition + 'px'
        } else if (newTop > pageHeight - dragHeight) {
          dragDom.style.top = pageHeight - dragHeight + 'px'
        } else {
          dragDom.style.top = newTop + 'px'
        }
      }
    })
    dragDom.addEventListener('touchend', () => {
      this.isDragged = false
  
      // 获取页面宽度和元素当前位置
      const pageWidth = document.documentElement.clientWidth
      const elementCenter = dragDom.offsetLeft + (dragDom.clientWidth / 2)
  
      // 判断元素中心点是在屏幕左半边还是右半边
      if (elementCenter < pageWidth / 2) {
        // 如果在左半边，则靠左吸附
        dragDom.style.left = '10px'
      } else {
        // 如果在右半边，则靠右吸附
        dragDom.style.left = `${pageWidth - dragDom.clientWidth - 10}px`
      }
  
      // 保存位置到 sessionStorage
      sessionStorage.setItem(
        'followDragPosition',
        JSON.stringify({
          top: dragDom.style.top,
          left: dragDom.style.left
        })
      )
    })
  },
   
  methods: {
    showDialog () {
      this.$sensors.track('Diversion_Click', {
        diversion_type: 'FLOAT',
        diversion_txt: this.flow.key
      })
      if (this.flow?.guidPageFlag !== 'Y') return
      this.$emit('on-showDialog')
    },
    handleClose () {
      this.showDom = false
    }
  }
}
</script>

<style lang="less" scoped>
@import "../../assets/less/mixin.less";

.api-follow-drag {
  width:124px;
  height: 140px;
  position: fixed;
  top: 0;
  right: 20px;
  z-index: 1000;
  display: flex;
  box-sizing: content-box;
  flex-direction: column;
  align-items: center;
  
  .container {
    width:124px;
    img{width: 100%;}
  }
  .close {
    width:24px;
    height:24px;
    position: absolute;
    top: -25px;
    right: 10px;
    background:url('./images/btn_close@2x.png') no-repeat;
    background-size: 24px 24px;
  }
  .wave {
    position: absolute;
    width:124px;
    height:120px;
    border:3px solid #FFCB7E;
    border-radius: 50%;
    animation: wave 1.5s infinite;
    left:0; top:0;
  }

  @keyframes wave {
    to {
      transform: scale(1.2) ;
      opacity: 0;
    }
  }
}
</style>